import React from 'react';
import Gallery from '../components/Gallery/Gallery';

export default function Home() {
  return (
    <div className="page-wrapper">
      <style dangerouslySetInnerHTML={{ __html: `
        .page-wrapper {
          background-color: #F0F9F7;
          min-height: 100vh;
          font-family: 'Montserrat', sans-serif;
          color: #2D3748;
          overflow-x: hidden;
        }

        /* HERO SECTION */
        .hero-section {
          display: flex;
          align-items: center;
          position: relative;
          background: linear-gradient(135deg, #FFFFFF 0%, #D1EAE5 100%);
          overflow: hidden;
          padding: 0 8%;
          height: 95vh;
        }

        .overlay-pattern {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background-image: radial-gradient(#1ABC9C 0.5px, transparent 0.5px);
          background-size: 30px 30px;
          opacity: 0.1;
          z-index: 1;
        }

        .hero-content {
          flex: 1;
          z-index: 10;
          padding-right: 5%;
        }

        .hero-title {
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 25px;
          color: #1E2D2A;
          letter-spacing: -2px;
          font-size: 4.5rem;
        }

        .hero-subtitle {
          font-size: 1.25rem;
          max-width: 550px;
          line-height: 1.8;
          color: #556B67;
        }

        /* BLOB ANIMATION - Оптимізовано для продуктивності */
        .blob-container {
          flex: 1.2;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2;
          aspect-ratio: 1/1; /* Запобігає CLS */
        }

        .morph-blob {
          width: 100%;
          height: 100%;
          background-image: url("/images/blob.jpg");
          background-size: cover;
          background-position: center;
          box-shadow: 0 30px 60px rgba(26, 188, 156, 0.25);
          border: 10px solid rgba(255,255,255,0.4);
          z-index: 3;
          animation: morph 10s ease-in-out infinite;
          will-change: border-radius; /* Оптимізація для GPU */
        }

        .morph-blob-bg {
          position: absolute;
          width: 105%;
          height: 105%;
          background: #1ABC9C;
          opacity: 0.15;
          filter: blur(50px);
          z-index: 2;
          animation: morph 14s ease-in-out infinite reverse;
        }

        @keyframes morph {
          0%, 100% { border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; transform: scale(1); }
          50% { border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%; transform: scale(1.02); }
        }

        /* INFO SECTION */
        .info-section {
          padding: 60px 10% 100px;
          display: flex;
          gap: 40px;
        }

        .glass-card {
          flex: 1;
          background: rgba(255, 255, 255, 0.7);
          backdrop-filter: blur(10px);
          padding: 50px 40px;
          border-radius: 40px;
          border: 1px solid rgba(255, 255, 255, 0.5);
          position: relative;
        }

        /* MEDIA QUERIES - Замість JavaScript Resize */
        @media (max-width: 768px) {
          .hero-section {
            flex-direction: column;
            height: auto;
            padding: 100px 5% 60px;
            text-align: center;
          }
          .hero-title {
            font-size: clamp(2rem, 10vw, 3rem);
            letter-spacing: -1px;
          }
          .hero-content { padding-right: 0; margin-bottom: 40px; }
          .info-section { flex-direction: column; padding: 40px 5%; }
          .blob-container { width: 100%; max-width: 350px; }
        }
      `}} />

      <section className="hero-section">
        <div className="overlay-pattern" />
        
        <div className="hero-content">
          <h1 className="hero-title">
            Простір для <br/> 
            <span style={{ color: '#1ABC9C' }}>відновлення</span> душі
          </h1>
          <p className="hero-subtitle">
            Ми переосмислили поняття медицини, створивши середовище, де технології працюють у синергії з природою та спокоєм.
          </p>
        </div>

        <div className="blob-container">
          <div className="morph-blob" />
          <div className="morph-blob-bg" />
        </div>
      </section>

      {/* РОЗДІЛЬНИК */}
      <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
        <div style={{ width: '80%', height: '1px', background: 'linear-gradient(to right, transparent, #1ABC9C, transparent)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <span style={{ background: '#F0F9F7', padding: '0 20px', color: '#1ABC9C', fontSize: '1.5rem' }}>✦</span>
        </div>
      </div>

      <section className="info-section">
        <div className="glass-card">
          <h3 style={{ color: '#1ABC9C', marginBottom: '15px' }}>Наші цінності</h3>
          <p style={{ lineHeight: '1.7' }}>Кожен пацієнт отримує індивідуальну траєкторію лікування в оточенні турботи.</p>
        </div>
        <div className="glass-card" style={{ borderLeft: '4px solid #1ABC9C' }}>
          <h3 style={{ color: '#1ABC9C', marginBottom: '15px' }}>Атмосфера</h3>
          <p style={{ lineHeight: '1.7' }}>М'яке освітлення та звуки природи допомагають зняти стрес.</p>
        </div>
      </section>

      <section style={{ padding: '0 0 100px 0' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h2 style={{ fontSize: '2.5rem', color: '#1E2D2A' }}>Естетика простору</h2>
          <div style={{ width: '60px', height: '3px', background: '#1ABC9C', margin: '15px auto' }} />
        </div>
        <Gallery />
      </section>
    </div>
  );
}